import type { MovieItem } from "@/mocks/movies";

interface EpisodeListProps {
  movie: MovieItem;
  current: number;
  onSelect: (ep: number) => void;
}

export default function EpisodeList({ movie, current, onSelect }: EpisodeListProps) {
  if (movie.type === "movie") {
    return (
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onSelect(1)}
          className={`flex items-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm transition-colors cursor-pointer ${
            current === 1
              ? "bg-primary-500 font-medium text-foreground-950"
              : "border border-background-300 text-foreground-700 hover:border-primary-400"
          }`}
        >
          <i className="ri-play-circle-line" />
          正片（HD 高清）
        </button>
      </div>
    );
  }

  const episodes = Array.from({ length: movie.episodes }, (_, i) => i + 1);

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar md:flex-wrap md:overflow-visible md:pb-0">
      {episodes.map((ep) => (
        <button
          key={ep}
          type="button"
          onClick={() => onSelect(ep)}
          className={`flex h-11 w-14 shrink-0 items-center justify-center rounded-md text-sm transition-colors cursor-pointer md:w-12 ${
            current === ep
              ? "bg-primary-500 font-medium text-foreground-950"
              : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-400"
          }`}
        >
          {ep}
        </button>
      ))}
    </div>
  );
}